import angular from 'angular';
import { MovimentacoesPeriodoSelectorController } from './movimentacoes-periodo-selector.controller';

export class MovimentacoesPeriodoSelectorComponent implements angular.IComponentOptions {
    static selector = 'movimentacoesPeriodoSelector';
    static controller = MovimentacoesPeriodoSelectorController;
    static template = require('!!html-loader!./movimentacoes-periodo-selector.component.html');
    static bindings = {
        periodos: '<',
        selectedPeriod: '<',
        periodosBusy: '<',
        novoPeriodoBusy: '<',
        canManage: '<',
        buildCreateForm: '&',
        onSelect: '&',
        onCreate: '&',
        onOpenAll: '&'
    };
}
